import { render, staticRenderFns } from "./licenseList.vue?vue&type=template&id=21a52907&scoped=true&"
import script from "./licenseList.vue?vue&type=script&lang=js&"
export * from "./licenseList.vue?vue&type=script&lang=js&"
import style0 from "./licenseList.vue?vue&type=style&index=0&id=21a52907&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a52907",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21a52907')) {
      api.createRecord('21a52907', component.options)
    } else {
      api.reload('21a52907', component.options)
    }
    module.hot.accept("./licenseList.vue?vue&type=template&id=21a52907&scoped=true&", function () {
      api.rerender('21a52907', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/license/licenseList.vue"
export default component.exports